import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }
  getSuperAdminOrderSalesReport(superadminreportparam: any) {
    return this.http.post(environment.baseUrl + AppConstant.SuperAdminSalesReport, superadminreportparam);
  }

  getOrderSalesReport(storeadminreportparam: any) {
    return this.http.post(environment.baseUrl + AppConstant.StoreAdminSalesReport, storeadminreportparam);
  }

  getSuperAdminEarningReport(reportparam: any) {    
    return this.http.post(environment.baseUrl + AppConstant.SUPER_ADMIN_EARNING_RPT, reportparam);
  }

  getStoreAdminEarningReport(reportparam: any) {
    return this.http.post(environment.baseUrl + AppConstant.STORE_ADMIN_EARNING_RPT, reportparam);
  }
  getStoreAdminEarningReportAp(storeId: number) {
    const reportparam = {
      UserId: localStorage.getItem('userId'),
      StoreId: storeId,
      FromDate: '',
      ToDate: '',
      SkipNoOfRecord: 0,
      TakeNoRecord: 0,
      StatusId: 1
    };
    return this.http.post(environment.baseUrl + AppConstant.STORE_ADMIN_EARNING_RPT, reportparam);
  }
}
